import axiosInstance from "../../config/Axios";

export const getSales = async ({ page = 1, limit = 10, ...filters } = {}) => {
    try {
        const offset = (page - 1) * limit;
        const response = await axiosInstance({
            method: 'get',
            url: '/api/duka/sales/',
            params: {
                limit,
                offset,
                ...filters
            }
        });
        return {
            data: response.data.results,
            total: response.data.count,
            next: response.data.next,
            previous: response.data.previous
        };
    } catch (error) {
        return Promise.reject(error);
    }
};

export const updateSale = async (id, saleData) => {
    try {
        return await axiosInstance({
            method: 'put',
            url: `/api/duka/sales/${id}/`,
            data: saleData
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const createSale = async (saleData) => {
    try {
        return await axiosInstance({
            method: 'post',
            url: '/api/duka/sales/',
            data: saleData
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const deleteSale = async (id) => {
    if (!id) {
        return Promise.reject(new Error('Sale ID is required'));
    }
    try {
        const response = await axiosInstance({
            method: 'delete',
            url: `/api/duka/sales/${id}/`,
        });
        return response;
    } catch (error) {
        console.error('Delete API Error:', error?.response?.data || error.message);
        return Promise.reject(error);
    }
};

export const bulkUploadSale = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      return await axiosInstance({
        method: "post",
        url: "/api/duka/bulk-upload-sales/",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
    } catch (error) {
      return Promise.reject(error);
    }
  };

export default {
    getSales,
    bulkUploadSale,
};